import { useEffect } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
    getUnreadNotificationsCount,
    listNotifications,
    markNotificationRead,
    markNotificationsRead
} from '../actions/notificationActions'

const formatNotificationDate = value => new Intl.DateTimeFormat('ar-SA', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
}).format(new Date(value))

const getNotificationIcon = type => {
    if(type === 'news') return 'far fa-newspaper'
    if(type === 'document') return 'far fa-folder-open'
    if(type === 'event') return 'far fa-calendar-check'
    if(type === 'member') return 'fas fa-user-alt'
    if(type === 'admin') return 'fas fa-cog'
    return 'far fa-bell'
}

const NotificationBell = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { notifications } = useSelector(state => state.notifications)
    const { count } = useSelector(state => state.notificationUnread)

    const unreadBadge = count > 0 && (
        <span className='navigation__badge'>{count > 99 ? '99+' : count}</span>
    )

    const notificationClickHandler = notification => {
        dispatch(markNotificationRead(notification._id))
        if(notification.link) history.push(notification.link)
    }

    const showAllHandler = () => {
        history.push('/notifications')
    }

    const markAllHandler = event => {
        event.stopPropagation()
        dispatch(markNotificationsRead())
        dispatch(listNotifications())
    }

    useEffect(() => {
        dispatch(getUnreadNotificationsCount())
        dispatch(listNotifications())
    }, [dispatch])

    return (
        <Dropdown alignRight className='notification-bell'>
            <Dropdown.Toggle as='button' className='notification-bell__button' aria-label='الإشعارات'>
                <i className='far fa-bell'></i>
                {unreadBadge}
            </Dropdown.Toggle>

            <Dropdown.Menu className='notification-bell__menu'>
                <div className='notification-bell__header'>
                    <strong>الإشعارات</strong>
                    <button type='button' onClick={markAllHandler}>تحديد الكل كمقروء</button>
                </div>

                <div className='notification-bell__list'>
                    {notifications && notifications.length > 0
                        ? notifications.slice(0, 5).map(notification => (
                            <button
                                type='button'
                                className='notification-bell__item'
                                key={notification._id}
                                onClick={() => notificationClickHandler(notification)}
                            >
                                <span className='notification-bell__icon'>
                                    <i className={getNotificationIcon(notification.type)}></i>
                                </span>
                                <span className='notification-bell__content'>
                                    <strong>{notification.title}</strong>
                                    <span>{notification.message}</span>
                                    <time>{formatNotificationDate(notification.createdAt)}</time>
                                </span>
                            </button>
                        ))
                        : <p className='notification-bell__empty'>لا توجد إشعارات حالياً</p>}
                </div>

                <button type='button' className='notification-bell__all' onClick={showAllHandler}>
                    عرض مركز الإشعارات
                </button>
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default NotificationBell
